import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (t, clickHandler) => {
  const formatPhoneNumber = (phoneNumber) => {
    // Format the phone number
    const formattedNumber = phoneNumber.replace(
      /(\d{2})(\d{4})(\d{4})/,
      "$1 $2 $3",
    );

    return formattedNumber;
  };

  let columndata = [
    {
      fieldtext: t("common:table-field.user-id"),
      field: "code",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: "Full name",
      field: "fullName",
      width: "180",
      textAlign: "Left",
    },
    {
      fieldtext: t("glossary:doctor-details.user-name"),
      field: "userName",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        const userName = typeof props.userName === "string" ? props.userName.trim() : "";
        return <Text text={userName || "-"} />;
      },
    },
    {
      fieldtext: t("common:table-field.email"),
      field: "email",
      minWidth: "280px",
      width: "280px",
      textAlign: "Left",
      key: 2,
    },
    
    {
      fieldtext: t("common:table-field.mobile-no"),
      field: "phoneNumber",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
      template: (props) => {
        return (
          <span>{`${props.phoneNumberDialCode} ${formatPhoneNumber(
            props.phoneNumber,
          )}`}</span>
        );
      },
    },
    {
      fieldtext: "Status",
      field: "isActive",
      width: "180",
      textAlign: "Left",
      template: (props) => {
        return (
          <Text text={props.isActive ? "Active" : "Inactive"} />
        );
      },
     
    },
    {
      fieldtext: t("common:table-field.created-date"),
      field: "createdOn",
      width: "180",
      textAlign: "Left",
      enableGroupByFormat: true,
    },
    {
      fieldtext: t("common:table-field.actions"),
      field: "actions",
      width: "88px",
      textAlign: "Left",
      allowSorting: false,
      headerTextAlign: "Left",
      key: 6,
      template: (props) => {
        return (
          <ActionButton
            clickHandler={(e) => clickHandler(e, props)}
            Options={[
              {
                id: 1,
                element: (
                  <Text
                    text={t("glossary:user.action.edit")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 2,
                isShow: !props.isPasswordReset,
                element: (
                  <Text
                    text={t("glossary:user.action.reset-password")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 3,
                isShow: props.isActive && props.baseUserStatus,
                element: (
                  <Text
                    text={t("glossary:user.action.inactivate-account")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 4,
                isShow: !props.isActive && !props.baseUserStatus,
                element: (
                  <Text
                    text={t("glossary:user.action.activate-account")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 5,
                element: (
                  <Text
                    text={t("glossary:auth.reset-otp-count.reset-otp-count")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
            ]}
          />
        );
      },
    },
  ];
  return columndata;
};
